import React from 'react';
import cx from 'classnames';

import Text from '../Text';
import Touchable from '../Touchable';
import Switch from '../Icons/Switch';

import styles from './NavigationProfileSwitcher.module.scss';

export interface NavigationProfileSwitcherProps {
  /** Apply CSS class to the container. */
  className?: Parameters<typeof cx>[0];
  /** Apply CSS class to the img container. */
  imgWrapperClassName?: Parameters<typeof cx>[0];
  /** Name of the team profile. */
  name: string;
  /** The function that will be called when the element is clicked. */
  onClick: () => void;
  /** Image source for profile avatar. */
  src?: string;
}

export const NavigationProfileSwitcher: React.FC<NavigationProfileSwitcherProps> = ({
  className,
  src,
  imgWrapperClassName,
  name,
  onClick,
}) => {
  return (
    <div className={cx(className)}>
      <Touchable onClick={onClick} className={styles.teamSwitcher}>
        <div className={cx(styles.imgWrapper, imgWrapperClassName)}>
          {src === undefined ? (
            <Text
              as='span'
              contrast='high'
              weight='semiBold'
              className={styles.initials}
            >
              {name.split('')[0]}
            </Text>
          ) : (
            <img src={src} alt={name} className={styles.img} />
          )}
        </div>
        <div className={styles.nameWrapper}>
          <Text size={14} weight='semiBold' as='span'>
            {name}
          </Text>
        </div>
        <div className={styles.switcherIconWrapper}>
          <Switch />
        </div>
      </Touchable>
    </div>
  );
};

export default NavigationProfileSwitcher;
export { styles };
